import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import App from '../../../App';
import AccountDetailsStyles from './AccountDetails.styled';
import Account from '../../components/Account/Account';
import * as dealerService from '../../../services/dealerService';
import * as homesService from '../../../services/homesService';
import { formatDealerName } from 'pubweb-smokey/dist/utils/formatters';
import { parseInitialPropsContext } from '../../../utils';
import Loading from '../../../images/svg/icons/Loading';
import { DXAccountContext } from '../../../contexts/DXAccountContext';
import { useAuthorization } from 'dx-sdk/build/authorization';
import { Redirect } from 'react-router-dom';

const AccountDetails = ({ dealer, homes }) => {
  const dxContext = useContext(DXAccountContext);
  const { isAuthenticated, isLoading } = useAuthorization();

  if (!isAuthenticated && !isLoading) {
    return <Redirect to="/myhome-account-login" />;
  }

  return (
    <App dealer={dealer} homes={homes}>
      <AccountDetailsStyles>
        <Helmet>
          <title>
            Account Details | {formatDealerName(dealer?.dealerName)}
          </title>
          <meta name="robots" content="noindex" />
        </Helmet>

        {dxContext?.state?.globalLoading ? (
          <div className="loading-screen-panel">
            <Loading width="150px" />
          </div>
        ) : (
          <>
            <Account dealer={dealer} />
          </>
        )}
      </AccountDetailsStyles>
    </App>
  );
};

AccountDetails.getInitialProps = async (ctx) => {
  return await parseInitialPropsContext(ctx, dealerService, homesService).catch(
    (e) => {
      console.error(e);
      return { redirectTo: '/error' };
    }
  );
};

export default AccountDetails;
